export interface MonthPoint {
  month: string;
  amount: number;
  bookings: number;
}

/** Chef earnings in baht, net of the platform fee. */
export const chefEarnings: MonthPoint[] = [
  { month: 'Mar', amount: 108000, bookings: 5 },
  { month: 'Apr', amount: 154000, bookings: 7 },
  { month: 'May', amount: 181000, bookings: 8 },
  { month: 'Jun', amount: 169000, bookings: 7 },
  { month: 'Jul', amount: 221000, bookings: 9 },
  { month: 'Aug', amount: 248000, bookings: 11 },
];

export const chefTopMenus = [
  { name: 'Baan Ploy tasting', bookings: 34, revenue: 742000 },
  { name: 'Weeknight Thai table', bookings: 41, revenue: 398000 },
  { name: 'Week of home-style Thai', bookings: 19, revenue: 122000 },
];

export const chefPayouts = [
  { id: 'po-1', period: '16–31 Aug', amount: 118600, status: 'paid', arriving: '2026-09-02' },
  { id: 'po-2', period: '1–15 Aug', amount: 129400, status: 'paid', arriving: '2026-08-18' },
  { id: 'po-3', period: '1–15 Sep', amount: 41200, status: 'scheduled', arriving: '2026-09-17' },
] as const;

/** Customer spend history, in baht. */
export const customerSpend: MonthPoint[] = [
  { month: 'Mar', amount: 0, bookings: 0 },
  { month: 'Apr', amount: 14200, bookings: 1 },
  { month: 'May', amount: 0, bookings: 0 },
  { month: 'Jun', amount: 38600, bookings: 1 },
  { month: 'Jul', amount: 11800, bookings: 1 },
  { month: 'Aug', amount: 29400, bookings: 1 },
];

export const customerCuisineSplit = [
  { cuisine: 'Thai', bookings: 4 },
  { cuisine: 'Isan', bookings: 2 },
  { cuisine: 'Japanese', bookings: 1 },
  { cuisine: 'Indian', bookings: 1 },
];
